export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1761869814148-2271f2b67cb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxzdXJ2ZXlvciUyMHRvdGFsJTIwc3RhdGlvbiUyMHN1bnNldHxlbnwwfHx8fDE3OTA5NTc5OTV8MA&ixlib=rb-4.1.0&q=85",
  gallery1: "https://images.unsplash.com/photo-1526593714223-37c814d5aea9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxzdXJ2ZXklMjBtb251bWVudCUyMHRvdGFsJTIwc3RhdGlvbnxlbnwwfHx8fDE3OTA5NTc5OTV8MA&ixlib=rb-4.1.0&q=85",
  gallery2: "https://images.unsplash.com/photo-1682663810771-89d21838530f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHwzZCUyMGxhc2VyJTIwc2Nhbm5lciUyMHN1cnZleW9yfGVufDB8fHx8MTc5MDk1Nzk5NXww&ixlib=rb-4.1.0&q=85",
  gallery3: "https://images.unsplash.com/photo-1603901622056-0a5bee231395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjaXZpbCUyMGVuZ2luZWVyaW5nJTIwZHJhd2luZ3xlbnwwfHx8fDE3OTA5NTgwMDV8MA&ixlib=rb-4.1.0&q=85",
  gallery4: "https://images.unsplash.com/photo-1630288214117-5ebf6c9de343?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxidWxsZG96ZXIlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc5MDk1Nzk5NXww&ixlib=rb-4.1.0&q=85",
  practice: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&q=85",
  map: "https://images.unsplash.com/photo-1722964440262-1e867d859cf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxjb2x1bWJ1cyUyMG9oaW8lMjBjaXR5c2NhcGV8ZW58MHx8fHwxNzkwOTU3OTk1fDA&ixlib=rb-4.1.0&q=85"
};

export const CONTACT = {
  email: "steve.l@ohiogeomatics.com",
  location: "Dublin, Ohio"
};

export const LOGO = "/ohio-geomatics-logo.png";

export const DISCIPLINES = [
  "Land Survey / Boundary / ALTA",
  "Civil / Stormwater Engineering",
  "Subsurface Utility Engineering",
  "3D Machine Control Guidance",
  "Agency / Contract Support"
];
